import { useEffect, useState } from "react";
import Model, { helper, Providers } from "@tripian/model";
import { providers } from "@tripian/core";
import moment from "moment";

const initialCatalog: Providers.OccasionGenius.CatalogGroup[] = [
  { title: "Events", items: [], parentTagIds: [] },
];

const useOccasionGeniusCatalog = (
  lat?: number,
  lng?: number,
  arrivalDate?: string,
  departureDate?: string
) => {
  const isActive =
    typeof window !== "undefined" &&
    window.tconfig &&
    Array.isArray(window.tconfig.TOUR_TICKET_PROVIDER_IDS)
      ? window.tconfig.TOUR_TICKET_PROVIDER_IDS.includes(
          Model.PROVIDER_ID.OCCASION_GENIUS
        )
      : false;

  const [occasionGeniusEvents, setOccasionGeniusEvents] = useState<
    Providers.OccasionGenius.Event[]
  >([]);
  const [occasionGeniusCatalog, setOccasionGeniusCatalog] =
    useState(initialCatalog);
  const [loadingOccasionGeniusCatalog, setLoadingOccasionGeniusCatalog] =
    useState<boolean>(isActive);

  useEffect(() => {
    if (occasionGeniusEvents) {
      setLoadingOccasionGeniusCatalog(true);
      const newCatalog: Providers.OccasionGenius.CatalogGroup[] =
        helper.deepCopy(initialCatalog);

      const eventsCategoryIndex = newCatalog.findIndex(
        c => c.title === "Events"
      );
      if (eventsCategoryIndex > -1) {
        newCatalog[eventsCategoryIndex].items = [...occasionGeniusEvents];
      }

      setOccasionGeniusCatalog(newCatalog);
      setLoadingOccasionGeniusCatalog(false);
    }
  }, [occasionGeniusEvents]);

  useEffect(() => {
    if (
      window.tconfig.TOUR_TICKET_PROVIDER_IDS.some(
        x => x === Model.PROVIDER_ID.OCCASION_GENIUS
      ) &&
      providers.occasionGenius &&
      lat &&
      lng &&
      arrivalDate &&
      departureDate &&
      window.tconfig.SHOW_TOURS_AND_TICKETS
    ) {
      const today = moment().startOf("day");
      const tomorrow = moment(today).add(1, "days");

      const updatedArrivalDate = moment(arrivalDate).isBefore(today)
        ? today.format("YYYY-MM-DD")
        : moment(arrivalDate).format("YYYY-MM-DD");
      const updatedDepartureDate = moment(departureDate).isBefore(today)
        ? tomorrow.format("YYYY-MM-DD")
        : moment(departureDate).format("YYYY-MM-DD");

      setLoadingOccasionGeniusCatalog(true);
      providers.occasionGenius
        .events(lat, lng, updatedArrivalDate, updatedDepartureDate)
        .then((events: Providers.OccasionGenius.Event[]) => {
          const filteredEvents = events.filter(e => e.event_name !== undefined);
          setOccasionGeniusEvents(filteredEvents);
        })
        .catch(error => {
          console.error("OccasionGenius fetch error:", error);
          setLoadingOccasionGeniusCatalog(false);
        })
        .finally(() => setLoadingOccasionGeniusCatalog(false));
    }
  }, [lat, lng, arrivalDate, departureDate]);

  return {
    occasionGeniusCatalog,
    loadingOccasionGeniusCatalog,
  };
};

export default useOccasionGeniusCatalog;
